import { AxiosResponse } from 'axios';
import { authApi, api } from 'hooks/useApi';

const postRequestPasswordReset = ({
  email,
}: {
  email: string;
}): Promise<AxiosResponse<any, any> | null> => {
  return api.post('/forgot-password/', { email });
};

const postPasswordResetSetNewPassword = ({
  token,
  newPassword,
}: {
  token: string;
  newPassword: string;
}): Promise<AxiosResponse<any, any> | null> => {
  return api.post('/reset-password/', { token, password: newPassword });
};

const postVerifyEmail = (): Promise<AxiosResponse<any, any> | null> => {
  return authApi.post('/auth/verify-email/');
};

export default {
  postRequestPasswordReset,
  postPasswordResetSetNewPassword,
  postVerifyEmail,
};
